import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appCustomEmail]'
})

export class CustomEmailDirective {

  customEmail: RegExp = new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$');

  @HostListener('paste', ['$event']) pasteClipboard(e: ClipboardEvent): boolean {
    const data = e.clipboardData.getData('text');
    return this.customEmail.test(data)? true:false;
  }

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent): boolean {
    return (e.keyCode === 8 || e.keyCode === 32 || e.keyCode === 37 || e.keyCode === 39)
    ? true : this.customEmail.test(e.key);
  }
} 